export default [
  {
    title: 'React Patterns',
    description:
      'Why React Patterns are so critical to your success as an abstraction author.',
    startDatetime: 1600707600000, // timestamp in milliseconds (https://www.epochconverter.com/)
    calendarUrl:
      'https://calendar.google.com/event?action=TEMPLATE&tmeid=MmRzYzBhOWxsNjA0Mm1kY2VwaGJoYzJnY3AgOHM5ZHM1YmpyZzNhdHBoZW1nb2ozcnI5dTBAZw&tmsrc=8s9ds5bjrg3atphemgoj3rr9u0%40group.calendar.google.com',
    livestreamUrl: 'https://www.youtube.com/watch?v=WV0UUcSPk-0',
  },
  {
    title: 'Never Use Shallow Rendering',
    description:
      'Tests should help me be confident that my application is working and tests that use shallow rendering are tests that need to be baby-sat.',
    startDatetime: 1600794000000,
    calendarUrl:
      'https://calendar.google.com/event?action=TEMPLATE&tmeid=MGpwbjE4MzlrajI0NWIybGxrdWVpb2llYTQgOHM5ZHM1YmpyZzNhdHBoZW1nb2ozcnI5dTBAZw&tmsrc=8s9ds5bjrg3atphemgoj3rr9u0%40group.calendar.google.com',
    livestreamUrl: 'https://www.youtube.com/watch?v=zkpwdw_JWBg',
  },
  {
    title: 'AMA about React & Epic React',
    startDatetime: 1600880400000,
    calendarUrl:
      'https://calendar.google.com/event?action=TEMPLATE&tmeid=NXIzZG40YzlkNGxsM2tuOW1hZ25zMDJiMmEgOHM5ZHM1YmpyZzNhdHBoZW1nb2ozcnI5dTBAZw&tmsrc=8s9ds5bjrg3atphemgoj3rr9u0%40group.calendar.google.com',
    livestreamUrl: 'https://www.youtube.com/watch?v=gl4X59r6FnE',
  },
  {
    title: 'Tour of EpicReact.Dev',
    startDatetime: 1601053200000,
    calendarUrl:
      'https://calendar.google.com/event?action=TEMPLATE&tmeid=M3EzaGtqaXBwY29rbzNlY2w0M2lja3QyYm0gOHM5ZHM1YmpyZzNhdHBoZW1nb2ozcnI5dTBAZw&tmsrc=8s9ds5bjrg3atphemgoj3rr9u0%40group.calendar.google.com',
    livestreamUrl: 'https://www.youtube.com/watch?v=U-DFEZXbnkE',
  },
  {
    title: 'EpicReact.Dev Q&A',
    startDatetime: 1601312400000,
    calendarUrl:
      'https://calendar.google.com/event?action=TEMPLATE&tmeid=NHBrazYwdGZqMGtmbThucnBjbnYwZmcya2MgOHM5ZHM1YmpyZzNhdHBoZW1nb2ozcnI5dTBAZw&tmsrc=8s9ds5bjrg3atphemgoj3rr9u0%40group.calendar.google.com',
    livestreamUrl: 'https://www.youtube.com/watch?v=3pVB-tzac5o',
  },
  {
    title: 'EpicReact is LIVE! What EpicReact.Dev is all about',
    startDatetime: 1601398800000,
    calendarUrl:
      'https://calendar.google.com/event?action=TEMPLATE&tmeid=MmluaDZwZWs3NWRpdmFta2FpaDY3NGRndW8gOHM5ZHM1YmpyZzNhdHBoZW1nb2ozcnI5dTBAZw&tmsrc=8s9ds5bjrg3atphemgoj3rr9u0%40group.calendar.google.com',
    livestreamUrl: 'https://www.youtube.com/watch?v=Lr1fE1oLWjM',
  },
  {
    title: 'EpicReact is LIVE! What EpicReact.Dev is all about',
    startDatetime: 1601485200000,
    calendarUrl:
      'https://calendar.google.com/event?action=TEMPLATE&tmeid=MGpvcDZhbGdpcGY3bm5oZWlpNmtmaGgxYnQgOHM5ZHM1YmpyZzNhdHBoZW1nb2ozcnI5dTBAZw&tmsrc=8s9ds5bjrg3atphemgoj3rr9u0%40group.calendar.google.com',
    livestreamUrl: 'https://www.youtube.com/watch?v=YYAb-t5Pvck',
  },
  {
    title: 'EpicReact.Dev Review of React Fundamentals',
    description: `Learn everything you need to be effective with the fundamental building block of React applications. When you’re finished, you’ll be prepared to create React components to build excellent experiences for your app's users. We'll review the material for the workshop and answer any questions you have about it.`,
    startDatetime: 1601571600000,
    calendarUrl:
      'https://calendar.google.com/event?action=TEMPLATE&tmeid=MTgzMTY0ZzJqNXZhOW1xaGtndHMyMjM0ZzYgOHM5ZHM1YmpyZzNhdHBoZW1nb2ozcnI5dTBAZw&tmsrc=8s9ds5bjrg3atphemgoj3rr9u0%40group.calendar.google.com',
    livestreamUrl: 'https://www.youtube.com/watch?v=qmSXWPsonfg',
  },
  {
    title: 'EpicReact.Dev Review of React Hooks',
    description: `Learn the ins and outs of React Hooks. I will take you on a deep dive into React Hooks, and show you what you need to know to start using them in your applications right away. We'll review the material for the workshop and answer any questions you have about it.`,
    startDatetime: 1601658000000,
    calendarUrl:
      'https://calendar.google.com/event?action=TEMPLATE&tmeid=NXVuOHBldGhqYjNocmFiYnBicTU2YWgzNXAgOHM5ZHM1YmpyZzNhdHBoZW1nb2ozcnI5dTBAZw&tmsrc=8s9ds5bjrg3atphemgoj3rr9u0%40group.calendar.google.com',
    livestreamUrl: 'https://www.youtube.com/watch?v=qyuwWlhyBqc',
  },
  {
    title: 'EpicReact.Dev Review of Advanced React Hooks',
    description: `We’ll look at some of the more advanced hooks and ways they can be used to optimize your components and custom hooks. We’ll also look at several patterns you can follow to make custom hooks that provide great APIs for developers to be productive building applications. We'll review the material for the workshop and answer any questions you have about it.`,
    startDatetime: 1601917200000,
    calendarUrl:
      'https://calendar.google.com/event?action=TEMPLATE&tmeid=N2E2c2UxMGk4ajgwZ2RycTJtOG12MTJnamQgOHM5ZHM1YmpyZzNhdHBoZW1nb2ozcnI5dTBAZw&tmsrc=8s9ds5bjrg3atphemgoj3rr9u0%40group.calendar.google.com',
    livestreamUrl: 'https://www.youtube.com/watch?v=y_6tdBzljBY',
  },
  {
    title:
      'Livestream with Kent: EpicReact.Dev Review of Advanced React Patterns',
    description: `Not only learn great patterns you can use but also the strengths and weaknesses of each, so you know which to reach for to provide your custom hooks and components the flexibility and power you need. We'll review the material for the workshop and answer any questions you have about it.`,
    startDatetime: 1602003600000,
    calendarUrl:
      'https://calendar.google.com/event?action=TEMPLATE&tmeid=NDk4c2VpZzB0aGxiMmhrbThwN2lwaGluZDUgOHM5ZHM1YmpyZzNhdHBoZW1nb2ozcnI5dTBAZw&tmsrc=8s9ds5bjrg3atphemgoj3rr9u0%40group.calendar.google.com',
    livestreamUrl: 'https://www.youtube.com/watch?v=rEMtM5vsWE8',
  },
  {
    title: 'EpicReact.Dev Review of React Performance',
    description: `Learn everything you need to diagnose, profile, and fix performance problems in your React application using the Browser Performance Profiler, React DevTools Profiler, and proven React optimization techniques. We'll review the material for the workshop and answer any questions you have about it.`,
    startDatetime: 1602090000000,
    calendarUrl:
      'https://calendar.google.com/event?action=TEMPLATE&tmeid=Mzc0dTltMTFtdXNwcnRuc2Y3azZmYWN1aDggOHM5ZHM1YmpyZzNhdHBoZW1nb2ozcnI5dTBAZw&tmsrc=8s9ds5bjrg3atphemgoj3rr9u0%40group.calendar.google.com',
    livestreamUrl: 'https://www.youtube.com/watch?v=aXVpX7eRRd8',
  },
  {
    title: 'EpicReact.Dev Review of Testing React Apps',
    description: `In this hands-on workshop you'll learn everything you need to test React components and applications with ease and get the knowledge you need to ship your applications with confidence. We'll review the material for the workshop and answer any questions you have about it.`,
    startDatetime: 1602176400000,
    calendarUrl:
      'https://calendar.google.com/event?action=TEMPLATE&tmeid=MmtsMWdodjdxNjZsY2xuMWJob2I2ZzV0ZmIgOHM5ZHM1YmpyZzNhdHBoZW1nb2ozcnI5dTBAZw&tmsrc=8s9ds5bjrg3atphemgoj3rr9u0%40group.calendar.google.com',
    livestreamUrl: 'https://www.youtube.com/watch?v=rJr3EZXf2ms',
  },
  {
    title: 'EpicReact.Dev Review of React Suspense',
    description: `Learn how Suspense works under the hood, preparing you for the future of asynchronous state management. We'll review the material for the workshop and answer any questions you have about it.`,
    startDatetime: 1602262800000,
    calendarUrl:
      'https://calendar.google.com/event?action=TEMPLATE&tmeid=MnRib2xjbGxoM3NhM2U5aDllYmIyM3NsdTAgOHM5ZHM1YmpyZzNhdHBoZW1nb2ozcnI5dTBAZw&tmsrc=8s9ds5bjrg3atphemgoj3rr9u0%40group.calendar.google.com',
    livestreamUrl: 'https://www.youtube.com/watch?v=39K7X_6mR8M',
  },
  {
    title:
      'Livestream with Kent: EpicReact.Dev Review of Build an Epic React App',
    description: `The React and JavaScript ecosystem is full of tools and libraries to help you build your applications. In this (huge) workshop we’ll build an application from scratch using widely supported and proven tools and techniques. We’ll cover everything about building frontend React applications, from the absolute basics to the tricky parts you'll run into building real world React apps and how to create great abstractions. We'll review the material for the workshop and answer any questions you have about it.`,
    startDatetime: 1602522000000,
    calendarUrl:
      'https://calendar.google.com/event?action=TEMPLATE&tmeid=NGwxYTFjYXVyZDBmMnBhbXBqbDdqa2h2ODkgOHM5ZHM1YmpyZzNhdHBoZW1nb2ozcnI5dTBAZw&tmsrc=8s9ds5bjrg3atphemgoj3rr9u0%40group.calendar.google.com',
    livestreamUrl: 'https://www.youtube.com/watch?v=W4JWlf5q4Xc',
  },
  {
    title:
      'Livestream with Kent: EpicReact.Dev Review of Epic React Expert Interviews',
    description: `Kent Interviews experts on various topics. We'll go over what topics are covered in the interviews as well as the interviewees themselves.`,
    startDatetime: 1602608400000,
    calendarUrl:
      'https://calendar.google.com/event?action=TEMPLATE&tmeid=MmJ2c2s1ZXBrYnA0YWxxZHZwa21pYW1hcmEgOHM5ZHM1YmpyZzNhdHBoZW1nb2ozcnI5dTBAZw&tmsrc=8s9ds5bjrg3atphemgoj3rr9u0%40group.calendar.google.com',
    livestreamUrl: 'https://www.youtube.com/watch?v=QYGLUrDBglE',
  },
  {
    title: 'EpicReact.Dev Final Q&A',
    description: `The EpicReact.Dev launch sale is almost over! Join us and get your last minute questions answered.`,
    startDatetime: 1602622800000,
    calendarUrl:
      'https://calendar.google.com/event?action=TEMPLATE&tmeid=MXRybDk4dGtnNTJmOWhmOTU4Mm1va2ZqaXEgOHM5ZHM1YmpyZzNhdHBoZW1nb2ozcnI5dTBAZw&tmsrc=8s9ds5bjrg3atphemgoj3rr9u0%40group.calendar.google.com',
    livestreamUrl: 'https://www.youtube.com/watch?v=nZTVrhdkJBE',
  },
]
